import { d as t } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var d = {
  name: "tg",
  weekdays: "якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе".split("_"),
  months: "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),
  weekStart: 1,
  weekdaysShort: "яшб_дшб_сшб_чшб_пшб_ҷум_шнб".split("_"),
  monthsShort: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
  weekdaysMin: "яш_дш_сш_чш_пш_ҷм_шб".split("_"),
  ordinal: function(_) {
    return _;
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "DD/MM/YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd, D MMMM YYYY HH:mm"
  },
  relativeTime: {
    future: "баъди %s",
    past: "%s пеш",
    s: "якчанд сония",
    m: "як дақиқа",
    mm: "%d дақиқа",
    h: "як соат",
    hh: "%d соат",
    d: "як рӯз",
    dd: "%d рӯз",
    M: "як моҳ",
    MM: "%d моҳ",
    y: "як сол",
    yy: "%d сол"
  }
};
t.locale(d, null, !0);
export {
  d as default
};
